import React from 'react';
import { KpiGrid, type KpiItem } from '@/components/ui/KpiGrid';
import { Droplets, Zap, Activity, AlertTriangle, PenTool, CheckCircle2 } from 'lucide-react';

export function UtilityKpiDashboard() {
  const kpis: KpiItem[] = [
    {
      title: 'Hệ thống Quản lý',
      value: 12,
      suffix: 'Hệ thống',
      icon: Activity,
      color: 'text-indigo-600',
      bg: 'bg-indigo-50',
      trend: 'up',
      trendValue: 'Đồng bộ',
      chartColor: 'bg-indigo-500',
      chartData: [10, 11, 11, 12, 12, 12, 12]
    },
    {
      title: 'Lưu lượng Nước',
      value: '4.5',
      suffix: 'k m³',
      icon: Droplets,
      color: 'text-blue-600',
      bg: 'bg-blue-50',
      trend: 'down',
      trendValue: 'Tiết kiệm',
      chartColor: 'bg-blue-500',
      chartData: [5.2, 5.0, 4.8, 4.6, 4.7, 4.5, 4.5]
    },
    {
      title: 'Tiêu thụ Điện',
      value: '22',
      suffix: 'k kWh',
      icon: Zap,
      color: 'text-amber-600',
      bg: 'bg-amber-50',
      trend: 'up',
      trendValue: 'Tháng này',
      chartColor: 'bg-amber-500',
      chartData: [20, 21, 20.5, 21.5, 22, 22, 22]
    },
    {
      title: 'Sự cố cần xử lý',
      value: 3,
      suffix: 'Điểm',
      icon: AlertTriangle,
      color: 'text-red-600',
      bg: 'bg-red-50',
      trend: 'down',
      trendValue: 'Đã giảm',
      chartColor: 'bg-red-500',
      chartData: [8, 6, 5, 4, 3, 3, 3]
    },
    {
      title: 'Đang bảo trì',
      value: 5,
      suffix: 'Trạm',
      icon: PenTool,
      color: 'text-purple-600',
      bg: 'bg-purple-50',
      trend: 'neutral',
      trendValue: 'Đúng tiến độ',
      chartColor: 'bg-purple-500',
      chartData: [4, 5, 5, 6, 5, 5, 5]
    },
    {
      title: 'Hiệu suất vận hành',
      value: 96,
      suffix: '%',
      icon: CheckCircle2,
      color: 'text-emerald-600',
      bg: 'bg-emerald-50',
      trend: 'up',
      trendValue: 'Tối ưu',
      chartColor: 'bg-emerald-500',
      chartData: [92, 93, 94, 94, 95, 96, 96]
    }
  ];

  return <KpiGrid kpis={kpis} />;
}
